<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="d-flex align-items-center mb-2" style="gap:10px;">
        <div class="section-title ">{{ $t("Email Logs") }}</div>

        <div class="px-2  w-25">
          <input
            v-model="searchLogs"
            :placeholder="$t('Search...')"
            class="form-control form-control-sm"
            type="search"
            v-on:input="onSearchLogs($event.target.value)"
            v-on:search="onSearchLogs($event.target.value)"
          />
        </div>
      </div>
      <div class="swc-report">
        <table border="1" class="swc-report-table mb-3">
          <thead>
          <tr>
            <th>{{ 'ID' }}</th>
            <th>{{ 'Type' }}</th>
            <th>{{ 'Emails' }}</th>
            <th>{{ 'Error' }}</th>
            <th>{{ $tc("Created") }} {{ $tc("At") }}</th>
          </tr>
          </thead>

          <tbody>
          <tr
            v-for="(log, macsIndex) in logsData"
            :key="macsIndex"
            :style="!log.error ? '' : 'color:red'"
            class="light_grey_back"
          >
            <td class="padd">{{ log.aml_id }}</td>
            <td class="padd">{{ String(log.type).toUpperCase() }}</td>
            <td class="padd">{{ log.emails }}</td>
            <td class="padd">{{ log.error }}</td>
            <td class="padd" style="text-align:right"> {{ log.created_at | fulldatemonparse }}</td>
          </tr>
          </tbody>

          <tbody v-if="logsData.length == 0">
          <tr>
            <td colspan="13">
              <NoRecords/>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <b-pagination
        v-if="reservationList.length > 0"
        v-model="currentPage"
        :per-page="perPage"
        :total-rows="rows"
        aria-controls="my-table"
        class="my-3"
        @change="onChangePagination($event)"
      ></b-pagination>
    </div>
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {DatePicker, Multiselect, NoRecords},
  data() {
    return {
      report_types: [
        {
          report_type: 1,
          name: 'Distributor Summary Report',
        },
        {
          report_type: 2,
          name: 'Aggregator Sales Report',
        },
        {
          report_type: 3,
          name: 'Summary & Performance Report',
        },
      ],
      frequency_type: [
        {
          frequency_type: 1,
          name: 'Daily',
        },
        {
          frequency_type: 2,
          name: 'Weekly',
        },
        {
          frequency_type: 3,
          name: 'Monthly',
        },
      ],
      logsData: [],
      tempData: [],
      macsSearch: "",

      CinemasCopy: [],
      searchLogs: "",
      btenable: false,
      selectedFilterValue: "",
      filterValues: [],
      filterValuesCopy: [],
      searchFilterValues: "",
      isRoleID: true,
      reservationList: [],
      reservationListCopy: [],
      searchUserValue: "",
      searchUsers: [],
      isSearchLoading: false,
      schedules: [],
      selected_ssid: "",
      selected_show_time: null,

      selectedFilter: "",
      users: ["Screen", "Movie", "User", "Show Booking Code"],
      fetchReservationDetail: {
        date: "",
        cinema_id: null,
        ssb_code: "",
        show_date: "",
        show_date_to: null,
        from_date: "",
        to_date: null
      },
      filterkey: "",
      filtervalue: "",
      selectedCinema: "",
      Cinemas: [],
      EjsData: null,
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [],
      sendMailObj: [],
      currencyData: "",

      searchReservations: ""
    };
  },
  beforeMount() {
    this.getMailLogs();
  },
  methods: {
    getMailLogs: function () {
      let loader = this.$loading.show();

      MasterService.getMailLogs()
      .then(response => {
        const {data} = response;

        if (data && data.status && data.Records.data.length > 0) {
          data.Records.data.forEach(x => {
            x.emails = ([x.to, x.cc, x.bcc].filter(x => x).join(','))
          })

          this.logsData = data.Records.data;
          this.tempData = data.Records.data;
        } else {
          console.log("data.message :", data.message);
        }
      })
      .finally(() => {
        loader.hide()
      });
    },
    onSearchLogs: function (value) {
      let search_value = String(this.searchLogs).toLowerCase();

      if (!search_value || search_value.length === 0) {
        this.logsData = this.tempData;
        return
      }

      let check_array = [
        "created_at",
        "id",
        "aml_id",
        "emails",
        "type",
        "error",
      ];

      this.logsData = this.tempData.filter(log => {
        let obj = {};
        let check = false;

        check_array.map(column => {
          if (typeof log[column] == "object") {
            obj[column] = JSON.stringify(log[column]).toLowerCase().includes(search_value);
          } else {
            obj[column] = String(log[column]).toLowerCase().includes(search_value);
          }

          if (!check && obj[column]) {
            check = true;
          }
        });

        return check;
      });
    }
  }
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}

.icon-size {
  padding-top: 14px;
  padding-bottom: 14px;
  margin: auto;
}

td {
  text-align: left;
  padding: 0px;
}

.padd {
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/AutoEmailerV2/autoemailreportlogs.vue